<template>
    <div :id="'dropdown-'+rowData.id"
         class="dropdown keep-inside-clicks-open dropdown-note-editor d-inline-block">
        <button type="button"
                class="btn p-0"
                :class="noteDescription ? 'primary-text-color' : 'text-muted'"
                data-toggle="dropdown">
            <app-icon name="file-text" :class="iconClass"/>
        </button>
        <div class="dropdown-menu p-primary mt-1">
            <div>
                <p class="text-secondary">
                    {{ noteTitle }}
                </p>
                <div class="mb-4">
                    <form class="position-relative mb-0"
                          :class="{'loading-opacity': loading}"
                          ref="form"
                          :data-url="url">
                        <app-overlay-loader v-if="loading"/>
                        <app-input
                            type="textarea"
                            v-model="formData.description"
                            :text-area-rows="4"
                            :error-message="$errorMessage(errors, 'description')"
                            :placeholder="$t('add_note_here')"
                        />
                    </form>
                </div>
                <div class="text-right">
                    <a href="#"
                       class="btn btn-secondary mr-1"
                       :class="{'disabled': loading}"
                       @click.prevent="closeDropDown">
                        {{ $t('cancel') }}
                    </a>
                    <a href="#"
                       class="btn btn-primary mr-1"
                       :class="{'disabled': loading}"
                       @click.prevent="submitData">
                        {{ $t('save') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormHelperMixins from "../../../common/Mixin/Global/FormHelperMixins";

export default {
    name: "AppNoteEditor",
    mixins: [FormHelperMixins],
    props: {
        id: {},
        url: {},
        rowData: {},
        noteTitle: {
            default: function () {
                return this.$t('default_note_title');
            }
        },
        noteDescription: {
            default: function () {
                return this.$t('default_note_description');
            }
        },
        method: {
            default: 'PATCH'
        },
        iconClass: {
            default: 'size-18'
        },
        editPermission: {
            default: true
        }
    },
    data() {
        return {
            formData: {
                _method: this.method,
                description: ''
            }
        }
    },
    mounted() {
        $('#dropdown-' + this.rowData.id).on('hidden.bs.dropdown', () => {
        })
    },
    methods: {
        closeDropDown() {
            $(".dropdown-menu").removeClass('show')
        },
        afterSuccess({data}) {
            this.loading = false;
            this.closeDropDown();
            this.$emit('note-submitted', this.formData.description);
            this.toastAndReload(data.message);
        },
    },
    watch: {
        noteDescription: {
            handler: function (noteDescription) {
                this.formData.description = noteDescription || '';
            },
            immediate: true
        }
    }
}
</script>

<style scoped lang="scss">
.dropdown {
    .dropdown-menu {
        width: 350px;

        .note {
            overflow-y: auto;
            max-height: 200px;
        }
    }
}
</style>